/* istanbul ignore file */

/**
 * Should have all locale keys used in this project with translations matching the language-region
 * code of this file.
 */
export default {
  numberAboveMin: 'Value must be greater than or equal to {0}',
  numberBelowMax: 'Value must be less than or equal to {0}',
  numberBetween: 'Value must be between {0} and {1}',
  optional: 'Optional'
};
